<template>
  <v-main class="pa-3 pb-4">
    <TabelaFuncionarios
   v-bind:lista-funcionarios-ativos="listaFuncionariosAtivos"
   v-bind:lista-funcionarios-desativos="listaFuncionariosDesativos"
   v-bind:descricao-funcionario="'Recepcionistas'"
   v-bind:tipo-funcionario="'0'"
   v-on:alterar-dados-funcionario="alterarDadosFuncionario"
   v-on:ativar-funcionario="ativarFuncionario"
   v-on:desativar-funcionario="desativarFuncionario"
  >
  </TabelaFuncionarios>

    <v-layout style="height: 90px; position: relative" right bottom>

      <v-btn  id="mybutton" top-of="footer" right fab dark color="teal darken-4" @click="cadastrarRecepcionista"  >
          <v-icon  dark>add</v-icon>
    </v-btn>
    </v-layout>
  </v-main>
</template>

<script>
import Cookies from 'js-cookie'
import TabelaFuncionarios from './../../../assets/components/TabelaFuncionarios'
import administradorUnidadeService from '../../../services/administradorUnidade.service'

export default {
  name: 'listaAdministrador',
  components: {
    TabelaFuncionarios
  },
  data () {
    return {
      page: 1,
      tipo: 2,
      listaFuncionariosAtivos: [],
      listaFuncionariosDesativos: [],
      listaFuncionarios: [],
      user: null
    }
  },

  mounted () {
    console.log('em mounted adm...')
    this.user = this.$store.getters.usuario
    this.retornarFuncionarios()
  },
  methods: {

    ativarFuncionario (item) {
      console.log('ativ')
      if (confirm('Deseja ativar esse painel?')) {
        // this.items.splice(index, 1)
        const index = this.listaFuncionariosDesativos.indexOf(item)
        console.log('excluir painel..')
        console.log(typeof (item.username))
        administradorUnidadeService.administradorUnidade.ativarFuncionario
        (item.username)
          .then(rsp => {
            console.log('rsp oi:')
            if (rsp.data == true) {
              this.listaFuncionariosDesativos.splice(index, 1)
              this.listaFuncionariosAtivos.push(item)
            }
          })
          .catch(err => {
            // handle your error here
            console.log(err)
          })
      }
    },

    cadastrarRecepcionista () {
      // this.$router.push({ name: 'cadastrarRecepcionistaUnidade', params: { item: item } })
      this.$router.push({ name: 'cadastrarRecepcionistaUnidade', params: { listaRecepcionistasCadastradas: this.listaFuncionarios } })
    },

    alterarDadosFuncionario (item) {
      this.$router.push({ name: 'alterarDadosRecepcionista', params: { item: item } })
    },

    desativarFuncionario (item) {
      console.log('desat')
      if (confirm('Deseja desativar esse painel?')) {
        // this.items.splice(index, 1)
        const index = this.listaFuncionariosAtivos.indexOf(item)
        console.log('excluir painel..')
        console.log(typeof (item.username))

        administradorUnidadeService.administradorUnidade.desativarFuncionario
        (item.username)
          .then(rsp => {
            console.log('rsp oi:')
            if (rsp.data == true) {
              this.listaFuncionariosAtivos.splice(index, 1)
              this.listaFuncionariosDesativos.push(item)
            }
          })
          .catch(err => {
          // handle your error here
            console.log(err)
          })
      }
    },

    retornarFuncionarios () {
      console.log('em retornar funcionarios atendente...')
      administradorUnidadeService.administradorUnidade
        .retornarFuncionarios(this.tipo)
        .then(rsp => {
          console.log('rsp oi:')
          console.log(rsp.data)
          this.listaFuncionarios = rsp.data
          this.listaFuncionarios.forEach(funcionario => {
            if (funcionario.ativo) {
              this.listaFuncionariosAtivos.push(funcionario)
            } else {
              this.listaFuncionariosDesativos.push(funcionario)
            }
          })
        })
        .catch(err => {
          // handle your error here
          console.log(err)
        })
    },
    alterarDadosRecepcionista (item) {
      console.log('em alterar dados..')
      this.$router.push({
        name: 'alterarDadosRecepcionista',
        params: { item: item }
      })
    },

    importarRecepcionistas () {
      console.log('em retornar funcionarios atendente...')
      administradorUnidadeService.administradorUnidade
        .importarRecepcionistas()
        .then(rsp => {
		  console.log('rsp oi:', rsp.data)
		  if (rsp.data == 'ok') {
            alert('Importação realizada com Sucesso!')
            this.listaFuncionarios = []
            this.listaFuncionariosAtivos = []
            this.listaFuncionariosDesativos = []
            this.retornarFuncionarios()
		  }
        })
        .catch(err => {
          // handle your error here
          console.log(err)
        })
    }
  },
  created () {
    console.log('created...')
  }
}
</script>

<style  scoped>
.md-card {
  width: 320px;
  margin: 4px;
  display: inline-block;
  vertical-align: top;
}

.feedback {
  background-color: #31b0d5;
  color: white;
  padding: 10px 20px;
  border-radius: 4px;
  border-color: #46b8da;
}

#mybutton {
  position: fixed;
  bottom: 20px;
  right: 10px;
}

#mybutton2 {
  position: fixed;
  bottom: 30px;
  right: 20px;
}
.rounded-card {
  border-radius: 35px;
}
</style>
